import { createTrackingUtils } from "../";
import { UITripRebookOption } from "@flights/types";
import { isPosIncludedInRebookE2eFlows } from "../../isPosIncludedInRebookE2eFlows";
import usePointOfSale from "../../../hooks/usePointOfSale";
import React from "react";

export const trackRebookFlowExperiment = createTrackingUtils({
  defaultStage: 1,
  name: "flights_web_pb_rebook_self_serve_m1",
  stages: {
    AFFECTED_USERS: 1,
    PRICE_REVIEW_SELF_SERVE_AVAILABLE: 2,
    SELECT_FLIGHT_MODAL: 3,
    CONFIRM_REBOOKING_PAGE_PAYMENT_NEEDED: 4,
    CONFIRM_REBOOKING_PAGE_NO_PAYMENT_NEEDED: 5,
    REBOOKING_REQUEST_RECEIVED_PAGE: 6,
    REBOOKING_SUCCESSFUL_PAGE: 7,
    REBOOKING_FAILED_PAGE: 8,
    REBOOKING_PENDING_PAGE: 9
  },
  goals: {
    CLICK_SELECT_FLIGHT_SEARCH_RESULTS: 1,
    CLICK_CS_CHANNEL: 2, // User clicks on "Book via chat" in base or "Select" in variant,
    CLICK_COST_BREAKDOWN: 3,
    CLICK_CONFIRM_PAY: 4,
    CLICK_BACK_ON_PAY: 5
  },
  goalsWithValue: []
});

export const useTrackRebookFlowExperiment = (
  rebookFlow: string | null | undefined,
  tripRebookOptions: UITripRebookOption[]
) => {
  const pos = usePointOfSale();

  // Check if POS is excluded from the e2e rebook self-serve experiment
  const isPosEligible = isPosIncludedInRebookE2eFlows(pos);
  // rebookingOfferReference is used to create a rebooking cart and indicates that booking could be rebooked by user
  // without reaching to help center via chat.
  const hasOfferReference = tripRebookOptions.some((tripRebookOption) => !!tripRebookOption.rebookingOfferReference);
  const isEligibleForSelfServe = rebookFlow === "CHANGE_TRIP_YOURSELF" && hasOfferReference && isPosEligible;

  return {
    isEligibleForSelfServe,
    isRebookFlowExperimentInVariant: isEligibleForSelfServe && trackRebookFlowExperiment.trackWithDefaultStage() === 1
  };
};

export const useTrackRebookFlowExperimentOrderDetailsPage = (rebookStatus: string | null) => {
  return React.useEffect(() => {
    switch (rebookStatus) {
      case "completed":
        trackRebookFlowExperiment.stages.REBOOKING_SUCCESSFUL_PAGE();
        break;
      case "failed":
        trackRebookFlowExperiment.stages.REBOOKING_FAILED_PAGE();
        break;
      case "pending":
        trackRebookFlowExperiment.stages.REBOOKING_PENDING_PAGE();
        break;
      default:
        break;
    }
  }, [rebookStatus]);
};
